import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieShield from "@/components/CookieShield";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import BlueprintGenerator from "@/pages/BlueprintGenerator";
import BlueprintView from "@/pages/BlueprintView";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutSuccessPublic from "@/pages/CheckoutSuccessPublic";
import CheckoutCancel from "@/pages/CheckoutCancel";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App relative">
      <div className="grain-overlay" />
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/commander" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/blueprint" element={<ProtectedRoute><BlueprintGenerator /></ProtectedRoute>} />
              <Route path="/blueprint/:id" element={<ProtectedRoute><BlueprintView /></ProtectedRoute>} />
              <Route path="/checkout/success" element={<CheckoutSuccessPublic />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
              <Route path="/vault/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
          <CookieShield />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0c0c0c",
                color: "#fff",
                border: "1px solid rgba(255, 215, 0, 0.3)",
                fontFamily: "Montserrat, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
